export function revealPopup(ele, time){
  $(ele).fadeIn(time);
  $('html,body').addClass('overflow');
}

export function closePopup(ele, time, removeClass) {
  const $ele = (typeof ele === 'string') ?  $(ele) : ele;
  $ele.fadeOut(time); 
  if (removeClass) {
    $('.radio-holder.clicked').removeClass('clicked');
    $('html, body').removeClass('overflow');
  }
}

$('.close').on('click', function() {
  const $popup = $(this).closest('.custom-popup');
  if ($('.custom-popup:visible').length >= 1) {
    closePopup($popup, 300, true);
  }else{
    closePopup($popup, 300, false);
  }
})

$('.form-popup .back').on('click', function() {
  closePopup('.form-popup', 300, false);
  revealPopup('.radio-popup', 300, false);
})

$('.features-popup .back').on('click', function() {
  closePopup('.features-popup', 300, false);
  revealPopup('.radio-popup', 300, false);
})



// WEBPACK FOOTER //
// ../markup/assets/js/custom-popup.js